import React, { useMemo, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@piplapps/pipl-ui';
import { Helmet } from 'react-helmet';
import UsageTable from './UsageTable';
import UsageFilters from './UsageFilters';
import styles from './UsagePerUser.module.less';

const EXPORT_POLLING_INTERVAL = 5000;

const Usage = (props) => {
  const usageColumns = [
    {
      Header: gettext(`User (${props.filteredUsageData?.length || 0})`),
      accessor: 'user',
      sortType: 'basic',
      id: 1,
    },
    {
      Header: gettext('Status'),
      accessor: 'assigned',
      id: 3,
    },
    {
      Header: gettext('Searches'),
      accessor: 'searches',
      id: 4,
    },
  ];
  if (props.isTeamManagement) {
    usageColumns.splice(1, 0, {
      Header: gettext('Teams'),
      accessor: 'teams',
      id: 2,
      sortType: 'basic',
    });
  }

  const columns = useMemo(() => usageColumns);

  const timerRef = useRef(null);

  const handleExport = useCallback(() => {
    const shouldStartPolling = !timerRef.current && props.exportRequestId;
    if (shouldStartPolling) {
      timerRef.current = setInterval(props.getExportRequestStatus, EXPORT_POLLING_INTERVAL);
    }
  }, [props.isExportRequestReady, props.getExportRequestStatus, timerRef.current, props.exportRequestId]);

  const handleCleanup = useCallback(() => {
    if (props.isExportRequestReady && timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  }, [timerRef.current, props.isExportRequestReady]);

  useEffect(handleExport, [handleExport]);
  useEffect(handleCleanup, [handleCleanup]);

  const onClickExport = useCallback(() => {
    if (!props.isExportLoading) {
      props.requestExport(props.timeFilter);
    }
  }, [props.isExportLoading, props.requestExport, props.timeFilter]);

  return (
    <div>
      <Helmet>
        <title>{gettext('Usage Per User')}</title>
      </Helmet>
      <div>
        <div className={styles.labelWrapper}>
          <Button
            buttonClass="label-blue"
            text={gettext('Export list')}
            loadingText={gettext('Generating...')}
            isLoading={props.isExportLoading}
            onClick={onClickExport}
          />
        </div>
        <div>
          <UsageFilters />
        </div>
        <div>
          <UsageTable columns={columns} data={props.filteredUsageData} isLoading={props.isLoading} tableProps={props} />
        </div>
      </div>
    </div>
  );
};

Usage.propTypes = {
  timeFilter: PropTypes.object,
  requestExport: PropTypes.func,
  isTeamManagement: PropTypes.bool,
  isLoading: PropTypes.bool,
  filteredUsageData: PropTypes.array,
  getExportRequestStatus: PropTypes.func,
  isExportRequestReady: PropTypes.bool,
  exportRequestId: PropTypes.string,
  isExportLoading: PropTypes.bool,
};

export default Usage;
